import AppFunction from "../../../../../core/helpers/app/AppFunction.js";

export const tableConditions = {
    data() {
        return {
            tableColumns: [
                { title: this.$t('name'), type: 'text', key: 'name' },
                {
                    title: this.$t('description'),
                    key: 'description',
                    type: 'custom-html',
                    isVisible: true,
                    headerClass: 'center', 
                    modifier: (value) => { 
                        if (value) {
                            return value; 
                        }
                        return '—';
                    }
                },
                { title: this.$t('action'), type: 'action', key: 'action' },
            ]
        };
    }
}